import { SVGProps, Ref, forwardRef } from 'react';

export const BriefcaseFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.597 3.511c3.104.084 4.067.681 4.32 3.221H.079c.253-2.54 1.217-3.137 4.32-3.22C4.929 1.783 6.036.5 7.998.5s3.069 1.284 3.6 3.011M5.887 3.5q.096-.239.21-.446C6.514 2.306 7.08 1.9 7.999 1.9s1.485.406 1.9 1.154q.116.207.212.446z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 8.832q0-.366.006-.7H15.99q.006.334.006.7v1.333c0 4.666-.667 5.332-5.332 5.332H5.332C.667 15.497 0 14.831 0 10.165zm10.33.7v1.4H5.666v-1.4z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
BriefcaseFilledSize16Glyph.displayName = 'BriefcaseFilledSize16Glyph';
